import { Component, OnInit } from '@angular/core';
import { FileService } from 'src/app/services/file.service';
import { FormServices } from 'src/app/services/form-services.service';
import { HttpService } from 'src/app/services/http.service';
import { UiServices } from 'src/app/services/ui-services';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-mail-view',
  templateUrl: './mail-view.page.html',
  styleUrls: ['./mail-view.page.scss'],
})
export class MailViewPage implements OnInit {
  public fieldForms: any = undefined;
  public domainId = environment.domainId;
  public isUploading = false;
  public savedForm: any = undefined;
  public id: number = undefined;

  constructor(
    private formSv: FormServices,
    private httpSv: HttpService,
    private uiSv: UiServices,
    private fileSv: FileService,
  ) { }

  async ngOnInit() {
    try{
      const res = await this.formSv.getForm('emailViewParameter', this.domainId);
      this.fieldForms = res;
    }catch(err){
      console.error(err);
    }
  }

  async sendInfo(ev: FormData){
    try{
      this.id && ev.set('id', this.id.toString());
      this.isUploading = true;
      const res: any = await this.httpSv.itemAction(ev, 'emailViewParemeters', this.id ? 'update' : 'store');
      this.isUploading = false;
      await this.uiSv.showToast('Email guardado exitosamente');
      if(res.status){
        // this.id = res.data.id;
        this.id = undefined;
        this.formSv.clearFormSrc.next();
        this.formSv.deleteListProductSrc.next('reloadListProduct');
      }
    }catch(err){
      console.error(err);
    }
  }

  async getCategories({ product, action, changeAction }){
    try{
      const { id, savedForm } = await this.fileSv.getProduct(
        { product, action, changeAction }, 
        this.id,
        'emailViewParemeters', 
        'Email', 
        this.savedForm
      );
      this.id = id;
      this.savedForm = savedForm;
    }catch(err){
      await this.uiSv.loading?.dismiss();
    }
  }
}
